<template>
  <div class="page-payment-status">
    <p>Payment success!</p>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'payment-success'
}
</script>
